import {
  AxisLabel,
  AxisRow,
  AxisSlot,
  Bar,
  BarSlot,
  BarsRow,
  ChartRoot,
} from './QueueDepthChart.styled'

export interface IQueueDepthBucket {
  value: number
  label?: string
}

interface IQueueDepthChart {
  data: IQueueDepthBucket[]
  height?: string
}

export const QueueDepthChart = ({ data, height = '8rem' }: IQueueDepthChart) => {
  const maxValue = Math.max(...data.map((d) => d.value), 1)

  return (
    <ChartRoot $height={height}>
      <BarsRow>
        {data.map((bucket, index) => (
          <BarSlot key={index}>
            <Bar $heightPercent={(bucket.value / maxValue) * 100} />
          </BarSlot>
        ))}
      </BarsRow>
      <AxisRow>
        {data.map((bucket, index) => (
          <AxisSlot key={index}>
            {bucket.label ? <AxisLabel grey>{bucket.label}</AxisLabel> : null}
          </AxisSlot>
        ))}
      </AxisRow>
    </ChartRoot>
  )
}
